<template>
	<vx-card
		class="prazo-card-responsaveis prazo-card mb-6"
	>
		<vs-collapse>
			<vs-collapse-item :open="true">
				<div slot="header">
					<div class="flex items-center">
						<h3 class="flex items-center text-lg">Filtro por responsavéis</h3>
						<vs-chip color="primary" class="ml-2 font-semibold">{{ $store.state.fitrosCalendarioPrazos.responsaveis.length }}</vs-chip>
					</div>
				</div>

				<div v-if="isSupervisor" class="supervision-filter border-b" @click.stop>
					<vs-checkbox
						class="supervision-filter__checkbox"
						v-model="$store.state.fitrosCalendarioPrazos.apenasMeusSupervisionados"
						@click.stop
						@change.stop
					>
						Apenas meus prazos supervisionados
					</vs-checkbox>
				</div>

				<VuePerfectScrollbar
					v-if="responsaveis && responsaveis.length"
					class="prazo-scroll-area"
					:settings="settingsPerfectScroll"
					@ps-scroll-y.native="scrollListener"
				>
					<vs-list class="prazo-responsaveis-list" :class="{'pb-24': responsaveis && responsaveis.length}">
						<label
							v-for="(responsavel, index) in responsaveis"
							:key="responsavel.pk || index"
							:for="'id-responsavel-' + responsavel.pk"
							class="cursor-pointer"
						>
							<vs-list-item
								:title="responsavel.nome"
								:subtitle="responsavel.perfil ? responsavel.perfil.nome : ''"
							>
								<template slot="avatar">
									<vs-avatar
										:src="responsavel.fotoThumb"
									/>
								</template>
								<vs-checkbox
									:id="'id-responsavel-' + responsavel.pk"
									v-model="
										$store.state.fitrosCalendarioPrazos
											.responsaveis
									"
									:vs-value="responsavel.pk"
								/>
							</vs-list-item>
						</label>
					</vs-list>
				</VuePerfectScrollbar>

				<div v-if="responsaveis && !responsaveis.length" class="nenhum-item">
					<h5 class="flex items-center text-sm mt-1">Nenhum responsável</h5>
				</div>
			</vs-collapse-item>
		</vs-collapse>
	</vx-card>
</template>

<script>
import Usuario from "../../../../../models/Usuario";
import Colaborador from "../../../../../models/Colaborador";
import scrollInfinito from '../../../../../helpers/getDataByScroll';

export default {
	name: "CardResponsaveis",
	data() {
		return {
			responsaveis: null,
			settingsPerfectScroll: {
				wheelSpeed: 0.2
			},
			responsaveisConfigs: {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
					ordering: "nome",
				},
                currentPage: 1,
                isMaxPage: false,
            },
		};
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		colaborador() {
			return Colaborador.getColaborador();
		},
		isSupervisor() {
			const colaborador = this.colaborador;
			const perfil = colaborador && colaborador.perfil;

			if (!perfil || typeof perfil === "string") {
				return false;
			}

			const perfilNome = (perfil.nome || "").toLowerCase();
			const privilegedNames = ["supervisor", "gestor", "administrador", "super adm"];

			const hasSuperuserPermission =
				(colaborador && colaborador.permissoes && colaborador.permissoes.autenticado && colaborador.permissoes.autenticado.superuser === true) ||
				false;

			return (
				perfil.isManager === true ||
				perfil.is_manager === true ||
				perfil.isAdmin === true ||
				perfil.is_admin === true ||
				privilegedNames.includes(perfilNome) ||
				hasSuperuserPermission
			);
		}
	},
	methods: {
		reordenarResponsaveis(responsaveis) {
			if (this.colaborador) {
				const index = responsaveis.findIndex(
					responsavel => responsavel.pk == this.colaborador.pk
				);
				if (index >= 0) {
					const responsavelRemovido = responsaveis.splice(index, 1);
					responsavelRemovido[0].nome =
						responsavelRemovido[0].nome + " [ EU MESMO ]";
					responsaveis.unshift(responsavelRemovido[0]);
				}
			}
		},
		async getResponsaveis() {
			const loadingResponsaveis = this.$vsloading({
				container: ".prazo-card-responsaveis .vs-collapse-item--content",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44,
				isFullPage: true
			});

			try {
				const { usuarios } = await Usuario.getUsuariosGerenciados(
					this.empresaPk,
					{
						limit: 20,
						ordering: "nome"
					}
				);

				this.reordenarResponsaveis(usuarios);

				this.responsaveis = usuarios;
				this.defaultResponsaveisConfigs();
			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingResponsaveis.hide, 200);
			}
		},
		async moreResponsaveis(params) {

            const data = {
                count: 0,
                data: []
            }

            try {

                if (!params) {
                    params = {limit: 20};
				}

				params["ordering"] = "nome";

                const { usuarios, totalUsuarios } = await Usuario.getUsuariosGerenciados(
					this.empresaPk,
					params
				);

				this.reordenarResponsaveis(usuarios);

                data.data = usuarios;

                data.count = totalUsuarios;

            } catch (error) {
				console.error(error);
            }

            return data;
        },
		async scrollListener(event) {

            this.responsaveisConfigs['getData'] = this.moreResponsaveis;

            let data = await scrollInfinito.run(event, this.responsaveisConfigs, true);

			if (data) {
				this.responsaveis = [
					...this.responsaveis,
					...data
				];
			}
		},
		defaultResponsaveisConfigs() {
            this.responsaveisConfigs = {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
					ordering: "nome",
				},
                currentPage: 1,
                isMaxPage: false,
            };
		},
	},
	mounted() {
		this.getResponsaveis();
	}
};
</script>

<style lang="scss" scoped src="./card_responsaveis.scss"></style>
